import '@frete.com/fuel-tokens/theme.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import Bugsnagjs from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import GenericError from '~containers/errors/GenericError';
import * as amplitude from '@amplitude/analytics-browser';

if (process.env.REACT_APP_MOCK === 'TRUE') {
  const { worker } = require('~mocks/browser');
  worker.start({ onUnhandledRequest: 'bypass' });
}

amplitude.init(process.env.REACT_APP_AMPLITUDE_KEY, {
  defaultTracking: {
    attribution: false,
    pageViews: false,
    sessions: false,
    formInteractions: false,
    fileDownloads: false,
  },
});

Bugsnagjs.start({
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.NODE_ENV,
  enabledReleaseStages: ['production', 'staging'],
});

const BugsnagBoundary = Bugsnagjs.getPlugin('react').createErrorBoundary(React);

ReactDOM.render(
  <React.StrictMode>
    <BugsnagBoundary FallbackComponent={GenericError}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </BugsnagBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
